import { bl_cms_calendar_event_link_RowClass } from '../../../dbschema/bl_cms_calendar_event_link.model';
import {BaseContainerModel} from '../../base-container.model';

export class CmsCalendarEventLinkContainerModel extends BaseContainerModel{
    bl_cms_calendar_event_link: bl_cms_calendar_event_link_RowClass = new bl_cms_calendar_event_link_RowClass();
}